import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { cn } from "@/lib/utils";
type InstructionsWrapperProps = React.ComponentProps<"div"> & {
  accordion?: boolean;
};
export const InstructionsWrapper = t0 => {
  const $ = _c(30);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      children,
      title: t1,
      className,
      accordion: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const title = t1 === undefined ? "Please follow the instructions carefully:" : t1;
  const accordion = t2 === undefined ? false : t2;
  let t3;
  if ($[6] !== title) {
    t3 = <h3 className="text-sm leading-[140%] font-medium bg-secondary/80 p-2 rounded w-full">{title}</h3>;
    $[6] = title;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const instructionTitle = t3;
  let t4;
  if ($[8] !== children) {
    t4 = <>{children}</>;
    $[8] = children;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const instructionContent = t4;
  if (accordion) {
    let t5;
    if ($[10] !== className) {
      t5 = cn("space-y-2 bg-secondary/20 p-2 rounded-md border border-border/20 [&_ol]:list-decimal [&_ul]:list-disc [&_ol,ul]:list-outside [&_ol,ul]:space-y-3 [&_ol,ul]:px-5 [&_ol,ul]:text-[13px]", className);
      $[10] = className;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    let t6;
    if ($[12] !== instructionTitle) {
      t6 = <AccordionTrigger className="p-0 w-full relative items-center [&_svg]:absolute [&_svg]:right-2">{instructionTitle}</AccordionTrigger>;
      $[12] = instructionTitle;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    let t7;
    if ($[14] !== instructionContent) {
      t7 = <AccordionContent asChild={true}>{instructionContent}</AccordionContent>;
      $[14] = instructionContent;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    let t8;
    if ($[16] !== t5 || $[17] !== t6 || $[18] !== t7 || $[19] !== title) {
      t8 = <Accordion collapsible={true} type="single"><AccordionItem className={t5} value={title}>{t6}{t7}</AccordionItem></Accordion>;
      $[16] = t5;
      $[17] = t6;
      $[18] = t7;
      $[19] = title;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    return t8;
  }
  let t5;
  if ($[21] !== className) {
    t5 = cn("space-y-2 bg-secondary/20 p-2 pb-4 rounded-md border border-border/20 [&_ol]:list-decimal [&_ul]:list-disc [&_ol,ul]:list-outside [&_ol,ul]:space-y-3 [&_ol,ul]:px-5 [&_ol,ul]:text-[13px]", className);
    $[21] = className;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== title) {
    t6 = <h3 className="text-sm leading-[140%] font-medium bg-secondary/80 p-2 rounded">{title}</h3>;
    $[23] = title;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== children || $[26] !== props || $[27] !== t5 || $[28] !== t6) {
    t7 = <div className={t5} {...props}>{t6}{children}</div>;
    $[25] = children;
    $[26] = props;
    $[27] = t5;
    $[28] = t6;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  return t7;
};